module.exports = __webpack_public_path__ + "static/img/product_images_15_h5_zh.c8bf1a5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/product_images_15_h5_zh.png
// module id = Nnkn
// module chunks = 34